import controller from './help-menu.controller';

const template = require('./help-menu.html');

export default {
    bindings: {
        mdPanelRef: '<'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/help-menu/help-menu.component.js